var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["learning-path-page", { mobile: _vm.isMobile(_vm.$mq) }] },
    [
      _vm.isMobile(_vm.$mq)
        ? _c("Mobile", { attrs: { "learning-path": _vm.learningPath } })
        : _c("Desktop", { attrs: { "learning-path": _vm.learningPath } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }